import React from "react";
import type { ThreadEvent } from "@/domain/threadEvent";
import { usePhotoViewer } from "@/components/photos/PhotoViewerProvider";

export function EMessage({ event }: { event: ThreadEvent }) {
  const photoViewer = usePhotoViewer();

  return (
    <div className="pm-emessage flex w-full flex-col gap-2">
      {event.text ? <div className="pm-emessage-text whitespace-pre-wrap">{event.text}</div> : null}
      {event.photos.length ? (
        <div className="pm-emessage-attachments grid grid-cols-3 gap-2">
          {event.photos.map((a, idx) => (
            <button
              key={`${a.url}:${idx}`}
              type="button"
              className="pm-emessage-attachment-button aspect-square w-full overflow-hidden rounded-md"
              onClick={() => photoViewer.open(event.photos, idx)}
              aria-label={`View attachment ${idx + 1}`}
            >
              <img
                src={a.url}
                alt={a.filename || "Attachment"}
                className="pm-emessage-attachment h-full w-full object-cover [image-orientation:from-image]"
                loading="lazy"
                decoding="async"
              />
            </button>
          ))}
        </div>
      ) : null}
      {event.videos.length ? (
        <div className="pm-emessage-videos flex flex-col gap-3">
          {event.videos.map((v) => (
            <video key={v.url} controls playsInline className="pm-emessage-video w-full rounded-md">
              <source src={v.url} type="video/mp4" />
            </video>
          ))}
        </div>
      ) : null}
    </div>
  );
}
